/* Careatic — single-source analytics + quick-add.
   ONE clean dataLayer push per interaction (no duplicate triggers). The theme
   already initialises window.dataLayer + GTM in <head>, so these feed GTM/GA4.
   Events: view_item_list, select_item, view_item, add_to_cart, begin_checkout,
   notify_request, select_promotion, sign_up. */
(function () {
  'use strict';

  /* One copy only. The file was included twice (head + ethnic PDP section) on 22 Sep 2026,
     which double fired every dataLayer push and so every GTM tag. */
  if (window.__caTrackingLoaded) return;
  window.__caTrackingLoaded = true;

  window.dataLayer = window.dataLayer || [];
  function caTrack(event, payload) {
    window.dataLayer.push(Object.assign({ event: event }, payload || {}));
  }
  window.caTrack = caTrack;

  /* ---- helper: read data-ca-* into a payload ---- */
  function payloadFrom(el) {
    var p = {};
    if (el.dataset.caItemId) p.item_id = el.dataset.caItemId;
    if (el.dataset.caItemName) p.item_name = el.dataset.caItemName;
    if (el.dataset.caListId) p.item_list_id = el.dataset.caListId;
    if (el.dataset.caPromotionId) p.promotion_id = el.dataset.caPromotionId;
    return p;
  }

  /* ---- click delegation: nearest [data-ca-track] wins (no double-fire) ---- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-ca-track]');
    if (!el) return;
    var event = el.dataset.caTrack;
    // add_to_cart is fired by the AJAX form handler below, not here
    if (event === 'add_to_cart' && el.closest('[data-ca-add-form]')) return;
    caTrack(event, payloadFrom(el));
  });

  /* ---- section-view: view_item_list fired once when a list scrolls in ---- */
  function observeLists() {
    var lists = document.querySelectorAll('[data-ca-list]');
    if (!('IntersectionObserver' in window) || !lists.length) {
      lists.forEach(function (l) { caTrack('view_item_list', { item_list_id: l.dataset.caList }); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          caTrack('view_item_list', { item_list_id: en.target.dataset.caList });
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.15 });
    lists.forEach(function (l) { io.observe(l); });
  }

  /* ---- quick add: fire ONE add_to_cart, then let the cart take over.
     We deliberately DO NOT preventDefault or AJAX the add ourselves — the
     Shiprocket Smart Cart app (and the native cart) intercept add-to-cart
     site-wide and open the slide-cart drawer that carries the Fastrr/Shiprocket
     "BUY NOW" button. Intercepting here would bypass that drawer. So we only
     attach tracking and let the form submit proceed, identical to every other
     add-to-cart on the store. If no cart app is active, the native POST lands
     on /cart (which also renders the Shiprocket checkout). ---- */
  function bindAddForms() {
    document.querySelectorAll('[data-ca-add-form]').forEach(function (form) {
      if (form.dataset.caBound) return;
      form.dataset.caBound = '1';
      form.addEventListener('submit', function () {
        var btn = form.querySelector('[data-ca-track="add_to_cart"]');
        caTrack('add_to_cart', {
          item_id: btn ? btn.dataset.caItemId : '',
          item_name: btn ? btn.dataset.caItemName : '',
          quantity: 1
        });
        // no preventDefault — the Shiprocket Smart Cart app / native cart takes over
      }, true); // capture: fire before the cart app's own submit handler
    });
  }

  function init() {
    observeLists();
    bindAddForms();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
